// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-submenu {
    position: relative;
}

.dropdown-submenu > .dropdown-menu {
    top: 0;
    left: 100%;
    margin-top: -6px;
    margin-left: -1px;
}

.dropdown-submenu:hover > .dropdown-menu {
    display: block;
}

.dropdown-submenu > a:after {
    display: block;
    content: " ";
    float: right;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-left-color: #cccccc;
    margin-top: 5px;
    margin-right: -10px;
}

.dropdown-submenu:hover > a:after {
    border-left-color: #ffffff;
}

.dropdown-submenu.pull-left {
    float: none;
}

.dropdown-submenu.pull-left > .dropdown-menu {
    left: -100%;
    margin-left: 10px;
}

@media (min-width: 768px) {
    .modal-dialog {
        width: 600px;
        margin: 30px auto;
    }

    .modal .modal-dialog {
        padding: 0; /* Always no padding and relative position since there is a clash with the google chart css file, which has a rule for .modal-dialog  */
        position: relative;
    }

    .modal-content {
        -webkit-box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);
        box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);
    }

    .modal-sm {
        width: 300px;
    }
}

@media (min-width: 992px) {
    .modal-lg {
        width: 900px;
    }
}

.label-primary[href]:hover,
.label-primary[href]:focus {
    background-color: #018ae1;
}

.panel-info > .panel-heading {
    color: #000000;
}

.nav .open > a,
.nav .open > a:hover,
.nav .open > a:focus {
    background-color: var(--gw-secondary-base);
    border-color: var(--gw-secondary-base);
}

.label-success {
    background-color: var(--gw-tertiary-base);
}

.panel-danger > .panel-heading {
    color: #fff;
    background-color: #f04124;
}

.modal .modal-dialog {
    padding: 0; /* Always no padding and relative position since there is a clash with the google chart css file, which has a rule for .modal-dialog  */
    position: relative;
}

/* Styles for the shortcuts directive */

#keyboardShortcuts {
    background-color: var(--gw-panel-background);
    padding: 0px 5px;
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 90%;
	z-index: 10;
}


.hotkeys-container {
    position: fixed;
    display: flex;
    flex-direction: column;
    bottom: 0;
    left: 0;
    max-width: 100vw;
    max-height: 40vh;
    overflow-y: auto;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 9998;
    border-radius: 10px 10px 0 0;
    font-weight: 300;
    min-width: 100vw;
    background-color: var(--gw-dialog-background);
    padding: 15px;
    border: 1px solid var(--gw-panel-border-color);
}

.hotkeys-container.fade {
  z-index: -1024;
  visibility: hidden;
  opacity: 0;
  -webkit-transition: opacity 0.15s linear;
  -moz-transition: opacity 0.15s linear;
  -o-transition: opacity 0.15s linear;
  transition: opacity 0.15s linear;
}

.hotkeys-container.fade.in {
  z-index: 10002;
  visibility: visible;
  opacity: 1;
}

.hotkeys {
    column-gap: 20px;
    overflow: auto;
    padding: 15px 18px 40px 0;
}

.hotkey-wrapper {
    overflow: auto;
}

@media (min-width: 1200px) {
    .hotkeys {
        column-count: 3;
    }
}

@media (max-width: 1199px) and (min-width: 577px) {
    .hotkeys {
        column-count: 2;
    }
}

@media (max-width: 576px) {
    .hotkeys {
        column-count: 1;
    }
}

.hotkeys .hotkey-section {
    width: 100%;
    margin-bottom: 15px;
    font-size: 1rem;
}

.hotkey-section .section-title {
    margin-bottom: 10px;
    font-weight: bold;
    color: var(--gw-shortcuts-panel-heading-color);
    font-size: 1rem;
    break-after: avoid;
}

.hotkey-section .hotkey-item {
    display: inline-flex;
    flex-direction: row;
    gap: 4px;
    margin: 8px 0;
    align-items: center;
    width: 100%;
}

.hotkey-item kbd {
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 28px;
    font-size: 16px;
    color: var(--gw-shortcuts-panel-key-color);
    background-color: var(--gw-shortcuts-panel-key-background);
    border-color: var(--gw-shortcuts-panel-key-border-color);
    border-radius: 2px;
    padding: 2px 8px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}

.hotkey-title {
    margin: 0.5rem 0;
    font-weight: 400;
    padding-bottom: 15px;
    flex-shrink: 0;
}

.hotkeys .ri-close-line {
	position: absolute;
	top: 20px;
	right: 30px;
    color: var(--gw-button-secondary-color);
    background-color: var(--gw-button-secondary-background);
    border: none;
    outline: none;
    cursor: pointer;
}

.hotkeys .ri-close-line:hover {
    color: var(--gw-button-primary-link-hover-color);
    font-weight: bold;
}

.hotkeys table {
  margin: auto;
  color: #333;
}

.hotkeys-keys {
  padding: 5px;
  text-align: right;
}

.hotkeys-text {
  padding-left: 10px;
}

[disabled-wrapper] {
    position: relative;
    z-index: 0;
}

[disabled-wrapper] div.disabled {
    cursor: not-allowed;
}

[disabled-wrapper] [disabled] {
    position: relative;
    z-index: -1;
}

.text-overflow-by-vw {
    max-width: 60vw !important;
}

.text-left {
    text-align: left;
}

.text-right {
    text-align: right;
}

@media only screen and (max-width:768px) {
    .fit-content-on-mobile {
        width: fit-content;
    }
}

@media only screen and (min-width:962px) {
    .update-ontop-repo-dialog .modal-dialog {
        min-width: 900px;
    }

    .update-ontop-repo-dialog .modal-dialog .modal-content {
        height: 800px;
    }

    .update-ontop-repo-dialog .modal-dialog .modal-content .form-group, .update-ontop-repo-dialog .modal-dialog .modal-content #wb-repository-file-textarea  {
        height: 100%;
    }

    .update-ontop-repo-dialog .modal-dialog .modal-content .modal-body {
        overflow: hidden;
    }
}

.update-ontop-repo-dialog .modal-dialog .modal-content .modal-body {
    font-family: var(--mono-font);
}

.help-info b {
    font-weight: 500;
}

.dynamic-form .dropdown-menu.multi-select {
    background-color: #fff !important;
    border: 1px solid rgba(0,0,0,.15) !important;
    border-radius: 0.25rem !important;
    position: absolute;
    left: 0;
    top: 100%;
    z-index: 1000;
    display: none;
    max-height: 200px;
    overflow-y: auto;
}

.dynamic-form .dropdown.multi-select > button {
    font-weight: 400 !important;
}

.dynamic-form .dropdown-item.multi-select {
    color: var(--gw-neutral-base) !important;
    font-weight: initial !important;
}

.dynamic-form .open > .dropdown-menu.multi-select {
    display: block;
    opacity: 1;
    margin-top: -1px;
}

.dynamic-form .dropdown-menu.multi-select .dropdown-item.multi-select {
    color: var(--gw-neutral-base) !important;
    font-weight: initial !important;
}

.dynamic-form button.form-control.dropdown-toggle.multi-select.text-left {
    position: relative;
}

.dynamic-form button.form-control.dropdown-toggle.multi-select.text-left::after {
    margin-left: 0 !important;
    position: absolute;
    right: 3px;
    top: 50%;
    transform: translateY(-50%);
    color: initial;
    font-size: smaller !important;
}
`, "",{"version":3,"sources":["webpack://./packages/legacy-workbench/src/css/workbench-custom.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,MAAM;IACN,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,UAAU,EAAE,uIAAuI;QACnJ,kBAAkB;IACtB;;IAEA;QACI,yLAAyL;QACzL,iLAAiL;IACrL;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,0CAA0C;IAC1C,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,UAAU,EAAE,uIAAuI;IACnJ,kBAAkB;AACtB;;AAEA,uCAAuC;;AAEvC;IACI,4CAA4C;IAC5C,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,cAAc;CACjB,WAAW;AACZ;;;AAGA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,aAAa;IACb,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,6CAA6C;IAC7C,aAAa;IACb,8CAA8C;AAClD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,wCAAwC;EACxC,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,8CAA8C;IAC9C,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0DAA0D;IAC1D,wDAAwD;IACxD,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;IACR,uCAAuC;IACvC,uDAAuD;IACvD,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,gDAAgD;IAChD,iBAAiB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,4CAA4C;IAC5C,iCAAiC;IACjC,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,6BAA6B;AACjC","sourcesContent":[".dropdown-submenu {\n    position: relative;\n}\n\n.dropdown-submenu > .dropdown-menu {\n    top: 0;\n    left: 100%;\n    margin-top: -6px;\n    margin-left: -1px;\n}\n\n.dropdown-submenu:hover > .dropdown-menu {\n    display: block;\n}\n\n.dropdown-submenu > a:after {\n    display: block;\n    content: \" \";\n    float: right;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid;\n    border-width: 5px 0 5px 5px;\n    border-left-color: #cccccc;\n    margin-top: 5px;\n    margin-right: -10px;\n}\n\n.dropdown-submenu:hover > a:after {\n    border-left-color: #ffffff;\n}\n\n.dropdown-submenu.pull-left {\n    float: none;\n}\n\n.dropdown-submenu.pull-left > .dropdown-menu {\n    left: -100%;\n    margin-left: 10px;\n}\n\n@media (min-width: 768px) {\n    .modal-dialog {\n        width: 600px;\n        margin: 30px auto;\n    }\n\n    .modal .modal-dialog {\n        padding: 0; /* Always no padding and relative position since there is a clash with the google chart css file, which has a rule for .modal-dialog  */\n        position: relative;\n    }\n\n    .modal-content {\n        -webkit-box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);\n        box-shadow: var(--gw-dialog-shadow-1-offset-x) var(--gw-dialog-shadow-1-offset-y) var(--gw-dialog-shadow-1-blur) var(--gw-dialog-shadow-1-spread) var(--gw-dialog-shadow-1-color);\n    }\n\n    .modal-sm {\n        width: 300px;\n    }\n}\n\n@media (min-width: 992px) {\n    .modal-lg {\n        width: 900px;\n    }\n}\n\n.label-primary[href]:hover,\n.label-primary[href]:focus {\n    background-color: #018ae1;\n}\n\n.panel-info > .panel-heading {\n    color: #000000;\n}\n\n.nav .open > a,\n.nav .open > a:hover,\n.nav .open > a:focus {\n    background-color: var(--gw-secondary-base);\n    border-color: var(--gw-secondary-base);\n}\n\n.label-success {\n    background-color: var(--gw-tertiary-base);\n}\n\n.panel-danger > .panel-heading {\n    color: #fff;\n    background-color: #f04124;\n}\n\n.modal .modal-dialog {\n    padding: 0; /* Always no padding and relative position since there is a clash with the google chart css file, which has a rule for .modal-dialog  */\n    position: relative;\n}\n\n/* Styles for the shortcuts directive */\n\n#keyboardShortcuts {\n    background-color: var(--gw-panel-background);\n    padding: 0px 5px;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    font-size: 90%;\n\tz-index: 10;\n}\n\n\n.hotkeys-container {\n    position: fixed;\n    display: flex;\n    flex-direction: column;\n    bottom: 0;\n    left: 0;\n    max-width: 100vw;\n    max-height: 40vh;\n    overflow-y: auto;\n    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n    z-index: 9998;\n    border-radius: 10px 10px 0 0;\n    font-weight: 300;\n    min-width: 100vw;\n    background-color: var(--gw-dialog-background);\n    padding: 15px;\n    border: 1px solid var(--gw-panel-border-color);\n}\n\n.hotkeys-container.fade {\n  z-index: -1024;\n  visibility: hidden;\n  opacity: 0;\n  -webkit-transition: opacity 0.15s linear;\n  -moz-transition: opacity 0.15s linear;\n  -o-transition: opacity 0.15s linear;\n  transition: opacity 0.15s linear;\n}\n\n.hotkeys-container.fade.in {\n  z-index: 10002;\n  visibility: visible;\n  opacity: 1;\n}\n\n.hotkeys {\n    column-gap: 20px;\n    overflow: auto;\n    padding: 15px 18px 40px 0;\n}\n\n.hotkey-wrapper {\n    overflow: auto;\n}\n\n@media (min-width: 1200px) {\n    .hotkeys {\n        column-count: 3;\n    }\n}\n\n@media (max-width: 1199px) and (min-width: 577px) {\n    .hotkeys {\n        column-count: 2;\n    }\n}\n\n@media (max-width: 576px) {\n    .hotkeys {\n        column-count: 1;\n    }\n}\n\n.hotkeys .hotkey-section {\n    width: 100%;\n    margin-bottom: 15px;\n    font-size: 1rem;\n}\n\n.hotkey-section .section-title {\n    margin-bottom: 10px;\n    font-weight: bold;\n    color: var(--gw-shortcuts-panel-heading-color);\n    font-size: 1rem;\n    break-after: avoid;\n}\n\n.hotkey-section .hotkey-item {\n    display: inline-flex;\n    flex-direction: row;\n    gap: 4px;\n    margin: 8px 0;\n    align-items: center;\n    width: 100%;\n}\n\n.hotkey-item kbd {\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    height: 28px;\n    font-size: 16px;\n    color: var(--gw-shortcuts-panel-key-color);\n    background-color: var(--gw-shortcuts-panel-key-background);\n    border-color: var(--gw-shortcuts-panel-key-border-color);\n    border-radius: 2px;\n    padding: 2px 8px;\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);\n}\n\n.hotkey-title {\n    margin: 0.5rem 0;\n    font-weight: 400;\n    padding-bottom: 15px;\n    flex-shrink: 0;\n}\n\n.hotkeys .ri-close-line {\n\tposition: absolute;\n\ttop: 20px;\n\tright: 30px;\n    color: var(--gw-button-secondary-color);\n    background-color: var(--gw-button-secondary-background);\n    border: none;\n    outline: none;\n    cursor: pointer;\n}\n\n.hotkeys .ri-close-line:hover {\n    color: var(--gw-button-primary-link-hover-color);\n    font-weight: bold;\n}\n\n.hotkeys table {\n  margin: auto;\n  color: #333;\n}\n\n.hotkeys-keys {\n  padding: 5px;\n  text-align: right;\n}\n\n.hotkeys-text {\n  padding-left: 10px;\n}\n\n[disabled-wrapper] {\n    position: relative;\n    z-index: 0;\n}\n\n[disabled-wrapper] div.disabled {\n    cursor: not-allowed;\n}\n\n[disabled-wrapper] [disabled] {\n    position: relative;\n    z-index: -1;\n}\n\n.text-overflow-by-vw {\n    max-width: 60vw !important;\n}\n\n.text-left {\n    text-align: left;\n}\n\n.text-right {\n    text-align: right;\n}\n\n@media only screen and (max-width:768px) {\n    .fit-content-on-mobile {\n        width: fit-content;\n    }\n}\n\n@media only screen and (min-width:962px) {\n    .update-ontop-repo-dialog .modal-dialog {\n        min-width: 900px;\n    }\n\n    .update-ontop-repo-dialog .modal-dialog .modal-content {\n        height: 800px;\n    }\n\n    .update-ontop-repo-dialog .modal-dialog .modal-content .form-group, .update-ontop-repo-dialog .modal-dialog .modal-content #wb-repository-file-textarea  {\n        height: 100%;\n    }\n\n    .update-ontop-repo-dialog .modal-dialog .modal-content .modal-body {\n        overflow: hidden;\n    }\n}\n\n.update-ontop-repo-dialog .modal-dialog .modal-content .modal-body {\n    font-family: var(--mono-font);\n}\n\n.help-info b {\n    font-weight: 500;\n}\n\n.dynamic-form .dropdown-menu.multi-select {\n    background-color: #fff !important;\n    border: 1px solid rgba(0,0,0,.15) !important;\n    border-radius: 0.25rem !important;\n    position: absolute;\n    left: 0;\n    top: 100%;\n    z-index: 1000;\n    display: none;\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n.dynamic-form .dropdown.multi-select > button {\n    font-weight: 400 !important;\n}\n\n.dynamic-form .dropdown-item.multi-select {\n    color: var(--gw-neutral-base) !important;\n    font-weight: initial !important;\n}\n\n.dynamic-form .open > .dropdown-menu.multi-select {\n    display: block;\n    opacity: 1;\n    margin-top: -1px;\n}\n\n.dynamic-form .dropdown-menu.multi-select .dropdown-item.multi-select {\n    color: var(--gw-neutral-base) !important;\n    font-weight: initial !important;\n}\n\n.dynamic-form button.form-control.dropdown-toggle.multi-select.text-left {\n    position: relative;\n}\n\n.dynamic-form button.form-control.dropdown-toggle.multi-select.text-left::after {\n    margin-left: 0 !important;\n    position: absolute;\n    right: 3px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: initial;\n    font-size: smaller !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
